import moment from 'moment';
import React from 'react';
import { Col, Row, Typography } from 'components';
import { CalendarIcon } from '../icons';
import styles from './styles.module.scss';
import { CommentItem } from './CommentItem';

interface CommentGroupProps {
  groupName: string;
  lastLogRef?: (node: Element | null) => void;
  firstLogRef?: (node: Element | null) => void;
  comments: any[];
  isLastGroup: boolean;
  isFirstGroup: boolean;
}

export const CommentsGroup: React.FC<CommentGroupProps> = (props) => {
  const { groupName, comments, isLastGroup, isFirstGroup, lastLogRef, firstLogRef } = props;
  return (
    <Col span={24}>
      <Row gutter={5} className={styles.group_title}>
        <Col>
          <Typography.Text>
            <CalendarIcon />
          </Typography.Text>
        </Col>
        <Col>
          <Typography.Text>{moment(groupName).format('DD.MM.YYYY')}</Typography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {comments.map((comment, index: number) => {
            const isLast = index === comments.length - 1 && isLastGroup;
            const isFirst = index === 0 && isFirstGroup;
            return (
              <CommentItem
                key={comment.id}
                comment={comment}
                logRef={isFirst ? firstLogRef : isLast ? lastLogRef : undefined}
              />
            );
          })}
        </Col>
      </Row>
    </Col>
  );
};
